import React, { useEffect, useState } from "react";

const getWarningStyle = (type) => {
  switch (type) {
    case "Datatype Mismatch":
      return "bg-yellow-100 text-yellow-800";
    case "Data Truncation":
      return "bg-blue-100 text-blue-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};

const MappingWarningsTable = ({
  data,
  selectedObjects,
  filteredMappingFiles,
}) => {
  const headerData = [
    "Object Name",
    "Record S.No",
    "Target Structure",
    "Field Name",
    "Warning Type",
    "Warning Details",
  ];

  const [selectedObjectsName, setSelectedObjectsName] = useState([]);
  const [allObjectsName, setAllObjectsName] = useState([]);

  useEffect(() => {
    const selectedObjectLabels = selectedObjects.map((object) =>
      object.description?.toLowerCase().trim()
    );
    setSelectedObjectsName([...selectedObjectLabels]);
  }, [selectedObjects]);

  useEffect(() => {
    const allObjectLabels = filteredMappingFiles.map((object) =>
      object.description?.toLowerCase().trim()
    );
    setAllObjectsName([...allObjectLabels]);
  }, [filteredMappingFiles]);

  return (
    <div className="objects-list" style={{ marginBottom: "2rem" }}>
      <h2 className="text-2xl font-semibold text-blue-900 mb-4">
        Record Level Mapping Warnings
      </h2>
      <div
        className="overflow-x-auto"
        style={{
          maxHeight: "400px",
          overflowY: "auto",
          border: "1px solid #e5e7eb",
          borderRadius: "0.375rem",
          position: "relative",
        }}
      >
        <table
          className="objects-table"
          style={{
            width: "100%",
            borderCollapse: "collapse",
          }}
        >
          <thead
            className="text-gray-600"
            style={{
              position: "sticky",
              top: 0,
              backgroundColor: "#f9fafb",
              zIndex: 10,
              // boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            <tr>
              {headerData?.map((data, index) => (
                <th
                  key={index}
                  style={{
                    padding: "12px 16px",
                    textAlign: "left",
                    fontWeight: "600",
                    borderBottom: "1px solid #e5e7eb",
                    backgroundColor: "#f9fafb",
                  }}
                >
                  {data}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((warn, idx) => {
              if (
                !selectedObjectsName.includes(
                  warn.objectDescription?.toLowerCase().trim()
                )
              ) {
                return null;
              }

              if (
                !allObjectsName.includes(
                  warn.objectDescription?.toLowerCase().trim()
                )
              ) {
                return null;
              }

              return (
                <tr
                  key={idx}
                  style={{
                    borderBottom: "1px solid #f3f4f6",
                    "&:hover": { backgroundColor: "#f9fafb" },
                  }}
                >
                  <td style={{ padding: "12px 16px" }}>
                    {warn.objectDescription}
                  </td>
                  <td style={{ padding: "12px 16px" }}>{warn.columnNumber}</td>
                  <td style={{ padding: "12px 16px" }}>
                    {warn.targetStructure}
                  </td>
                  <td style={{ padding: "12px 16px" }}>{warn.fieldName}</td>
                  <td style={{ padding: "12px 16px" }}>
                    <span
                      className={`text-xs px-2 py-1 rounded-full font-medium ${getWarningStyle(
                        warn.warningType
                      )}`}
                    >
                      {warn.warningType}
                    </span>
                  </td>
                  <td
                    className="text-gray-700"
                    style={{ padding: "12px 16px" }}
                    title={warn.warningDetails}
                  >
                    {warn.warningDetails.length > 25
                      ? warn.warningDetails.slice(0, 25) + "..."
                      : warn.warningDetails}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MappingWarningsTable;
